export const CACHE_MS = 1000 * 60 * 60 * 24;

export const cacheOptions = {
    staleTime: CACHE_MS,
    gcTime: CACHE_MS,
    refetchOnWindowFocus: false,
};

export const toList = (value: unknown): unknown[] => {
    if (!value) return [];
    return Array.isArray(value) ? value : Object.values(value as Record<string, unknown>);
};

export const fetchFirebaseData = async (path: string) => {
    const data = await fetch(`https://studio-6126571740-3d5b4-default-rtdb.firebaseio.com/${path}.json`);
    return data.json();
}